import { useState } from 'react'

import { Ematil2FASetup } from './setup'
import { DisableEmail2FA } from './disable'
import { MethodButtons } from './method-buttons.component'
import { SwitchTotp2FA } from './switch'
import { E2FAMethod, E2FAMethodTab } from 'src/types'

interface IProps {
  method: E2FAMethod | null
}

export const Email2FAInner = ({ method }: IProps) => {
  const [subTab, setSubTab] = useState<E2FAMethodTab>(E2FAMethodTab.Home)

  const handleHome = () => {
    setSubTab(E2FAMethodTab.Home)
  }
  const handleSubTab = (tab: E2FAMethodTab) => {
    setSubTab(tab)
  }

  return (
    <>
      <Ematil2FASetup method={method} />
      <MethodButtons subTab={subTab} method={method} setSubTab={handleSubTab} />
      <DisableEmail2FA method={method} subTab={subTab} returnBack={handleHome} />
      <SwitchTotp2FA method={method} subTab={subTab} returnBack={handleHome} />
    </>
  )
}
